import { saveUserSetting } from "@/shared/stores/saveUserSetting";
import { userSettingsStore } from "@/shared/stores/UserSettingsStore";
import { makeAutoObservable, runInAction } from "mobx";

const SECTION = "onboarding-replay";
const KEY = "card";

class TutorialStore {
  dismissed = false;
  loaded = false;
  private loadPromise: Promise<void> | null = null;
  private settingIdRef: { current: string | null } = { current: null };

  constructor() {
    makeAutoObservable(this, { settingIdRef: false, loadPromise: false } as any);
  }

  get enabled(): boolean {
    return !this.dismissed;
  }

  load(): Promise<void> {
    if (this.loaded) return Promise.resolve();
    if (this.loadPromise) return this.loadPromise;

    this.loadPromise = userSettingsStore.load().then(() => {
      const entry = userSettingsStore.getSetting(SECTION, KEY);
      const value = entry?.value as { dismissed?: unknown } | undefined;
      runInAction(() => {
        this.settingIdRef.current = entry?.id ?? null;
        this.dismissed = value?.dismissed === true;
        this.loaded = true;
      });
      this.loadPromise = null;
    });

    return this.loadPromise;
  }

  private persist() {
    void saveUserSetting(SECTION, KEY, { dismissed: this.dismissed }, this.settingIdRef);
  }

  setEnabled(enabled: boolean) {
    runInAction(() => {
      this.dismissed = !enabled;
    });
    this.persist();
  }
}

export const tutorialStore = new TutorialStore();
